<template>
  <transition name="fade">
    <div v-if="showComponent" id="powered-by-eventfinity-container">
      <span class="powered-by-text">Powered by</span>
      <div class="powered-by-eventfinity-logo" aria-label="Eventfinity Logo"></div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'PoweredByEventfinity',
  data() {
    return {
      showComponent: false
    };
  },
  mounted() {
    setTimeout(() => {
      this.showComponent = true;
    }, 1000)
  }
}
</script>

<style scoped>
#powered-by-eventfinity-container {
    display: flex;
    padding: 15px 0;
    justify-content: center;
    align-items: center;
    gap: 6px;
    align-self: stretch;
    font-size: 12px;
    background: #FFF;
    position: static;
    bottom: 0;
    width: 100%;
}

.registration-form #powered-by-eventfinity-container {
  position: absolute;
}

.powered-by-eventfinity-logo {
    background-image: url('/assets/base-event/global/EF-Logo.svg');
    background-size: contain;
    background-repeat: no-repeat; 
    width: 92px;
    height: 20px;
}
</style>
